import { api } from './client';
import type { Prompt, PromptSummary } from '../types';

interface CreatePromptRequest {
  name: string;
  system_prompt: string;
  user_prompt: string;
}

interface UpdatePromptRequest {
  name?: string;
  system_prompt?: string;
  user_prompt?: string;
}

export const promptsApi = {
  /**
   * Get all prompts (lightweight summary, no content)
   */
  list: (): Promise<PromptSummary[]> => {
    return api.get<PromptSummary[]>('/prompts');
  },

  /**
   * Get a single prompt by ID with full content
   */
  get: (id: string): Promise<Prompt> => {
    return api.get<Prompt>(`/prompts/${id}`);
  },

  /**
   * Create a new prompt
   */
  create: (data: CreatePromptRequest): Promise<Prompt> => {
    return api.post<Prompt>('/prompts', data);
  },

  /**
   * Update an existing prompt
   */
  update: (id: string, data: UpdatePromptRequest): Promise<Prompt> => {
    return api.patch<Prompt>(`/prompts/${id}`, data);
  },

  /**
   * Delete a prompt
   */
  delete: (id: string): Promise<void> => {
    return api.delete(`/prompts/${id}`);
  },

  /**
   * Set a prompt as active via app_settings
   */
  setActive: (id: string): Promise<Prompt> => {
    return api.post<Prompt>(`/prompts/${id}/set-active`, {});
  },
};
